const EChannelType = {
  Sns: "SNS",
  Chat: "CHAT",
  LiveStreaming: "LIVE_STREAMING",
} as const;

type EChannelType = typeof EChannelType[keyof typeof EChannelType];

export { EChannelType };
